export default __webpack_public_path__ + "02c62f3a22b99d25628452771ef039b9.png";